// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"43b3c9b5","178":"0a7681a9","218":"0a2e6b71","233":"9c2d2fe6","519":"59ddc249","682":"f096f1fe","734":"ffcfcb2d","942":"c06e06c7"}[chunkId] + ".chunk.js";
};